/* eslint-disable no-alert */
import React, { useState } from "react"
import styled from "styled-components"
import { Collapse } from "react-collapse"
import StyledSmallTitle from "../styled/styledSmallTitle"
import { StyledTitle } from "../Title"
import { faq } from "../../data/faq"
import { StyledButton } from "./CollapsedOffer"
import { StyledButton as DefaultButton } from "../Button"
import { ErrorMsg } from "../styled/styledInput"

const Container = styled.div`
  display: flex;
  align-items: center;
  padding-top: 24px;
  & h3 {
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0.25px;
    margin: 0 0 0 12px;
    @media (min-width: 1024px) {
      font-size: 24px;
      margin: 0 0 0 16px;
    }
  }
`

const StyledSection = styled.section`
  background-color: #fffcfa;
  padding: 48px 16px 12px;
  ${Container}:first-child {
    padding-top: 4px;
  }
  .ReactCollapse--collapse {
    transition: height 0.2s ease;
  }
  .ReactCollapse--content p {
    opacity: 0.6;
    margin-top: 16px;
    padding-left: 25px;
    margin-left: 14px;
    border-left: 2px solid #474dc4;
    letter-spacing: 0.3px;
    @media (min-width: 1024px) {
      font-size: 20px;
      line-height: 32px;
      padding-left: 31px;
    }
  }
  @media (min-width: 768px) {
    max-width: 576px;
    margin: 0 auto;
  }
  @media (min-width: 1024px) {
    padding: 60px 16px 12px;
    max-width: 900px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 65px;
    .title-box {
      grid-column: 1 / 3;
    }
  }
  @media (min-width: 1200px) {
    grid-column-gap: 130px;
    max-width: 1200px;
  }
`

const StillQuestion = styled.p`
  margin-top: 32px;
  padding-top: 24px;
  border-top: solid 1px #f9d6c1;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.3px;
  padding-right: 30%;
  @media (min-width: 1024px) {
    border-top: none;
    margin-top: 0;
    padding-top: 0;
    font-size: 24px;
    line-height: 32px;
    padding-right: 0;
  }
`

const StyledErrorMsg = styled(ErrorMsg)`
  opacity: 1;
  display: block;
  position: absolute;
  transform: translateY(-10px);
  z-index: -1;
  transition: transform 0.2s ease;
`

const StyledQuestionForm = styled.form`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  & label {
    margin-bottom: 28px;
    position: relative;
  }
  & input {
    padding-left: 15px;
    box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05),
      0 4px 6px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    border: solid 2px #fff;
    width: calc(100% - 20px);
    border-radius: 8px;
    outline: 0;
    font-size: 20px;
    height: 44px;
    &::placeholder {
      font-size: 20px;
      font-family: "Made Light", sans-serif;
      opacity: 0.6;
    }

    &:focus {
      &:invalid {
        border: 2px solid #c91919;
        & ~ ${StyledErrorMsg} {
          transform: translateY(22px);
          z-index: 1;
        }
      }
    }
  }
`

const Phone = styled.a`
  font-size: 20px;
  letter-spacing: 0.3px;
  line-height: 26px;
  margin-top: 12px;
  @media (min-width: 1024px) {
    margin-top: 16px;
  }
`
const ExtendStyledTitle = styled(StyledTitle)`
  @media (min-width: 1024px) {
    padding-right: 50%;
    &::after {
      width: 100%;
    }
  }
`

const StyledDefaultButton = styled(DefaultButton)`
  width: 100%;
  margin-top: 12px;
  box-shadow: 0 2px 8px 0 rgba(71, 77, 196, 0.5);
`

const FormBox = styled.div`
  @media (min-width: 1024px) {
    display: flex;
    padding-bottom: 30px;
    border-bottom: 1px solid #f9d6c1;
    margin-bottom: 20px;
    ${StyledDefaultButton} {
      width: 100px;
      border-radius: 0 8px 8px 0;
      height: 50px;
      margin-top: 0;
    }
    & input {
      border-radius: 8px 0 0 8px;
    }
    & label {
      margin-bottom: 0 !important;
      width: 100%;
    }
  }
`

const encode = data => {
  return Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join("&")
}

const FAQ = () => {
  const [activeCard, setActiveCard] = useState(0)
  const [contact, setContact] = useState(null)
  const [question, setQuestion] = useState(null)

  const handleSubmit = e => {
    e.preventDefault()
    // eslint-disable-next-line no-undef
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": "Question Form",
        // prettier-ignore
        "contact": contact,
        // prettier-ignore
        "question": question
      }),
    })
      .then(() => alert("Wysłano maila, dziękujemy!"))
      .catch(error => alert(error))
  }
  return (
    <StyledSection>
      <div className="title-box">
        <StyledSmallTitle>Faq</StyledSmallTitle>
        <ExtendStyledTitle>
          Często zadawane pytania
          <span> i oczywiście odpowiedzi</span>
        </ExtendStyledTitle>
      </div>
      <div>
        {faq.map(({ description, title }, i) => (
          <React.Fragment key={title}>
            <Container onClick={() => setActiveCard(i)}>
              <StyledButton
                type="button"
                className={i === activeCard && "active"}
              >
                <span />
                <span />
              </StyledButton>
              <h3>{title}</h3>
            </Container>
            <Collapse isOpened={i === activeCard}>
              {typeof description !== "string" ? (
                description
              ) : (
                <p>{description}</p>
              )}
            </Collapse>
          </React.Fragment>
        ))}
      </div>
      <div>
        <StillQuestion>Nadal masz pytanie?</StillQuestion>
        <StyledQuestionForm
          name="Question Form"
          method="post"
          data-netlify="true"
          onSubmit={e => handleSubmit(e)}
        >
          <input type="hidden" name="form-name" value="Question Form" />
          <label htmlFor="questionEmail">
            <input
              id="questionEmail"
              name="contact"
              type="text"
              placeholder="E-mail lub numer telefonu"
              required
              onChange={({ target: { value } }) => setContact(value)}
            />
            <StyledErrorMsg>
              Podaj adres E-mail lub numer telefonu
            </StyledErrorMsg>
          </label>
          <FormBox>
            <label htmlFor="question">
              <input
                id="question"
                name="question"
                type="text"
                placeholder="Zadaj pytanie"
                required
                onChange={({ target: { value } }) => setQuestion(value)}
              />
            </label>
            <StyledDefaultButton type="submit">Wyślij</StyledDefaultButton>
          </FormBox>
        </StyledQuestionForm>
        <StillQuestion>Chcesz wiedzieć więcej? Zadzwoń do nas.</StillQuestion>
        <Phone href="tel:500 211 637">+48 500 211 637</Phone>
      </div>
    </StyledSection>
  )
}

export default FAQ
